import setMatText from "../../lang/setMaterials.json";
import {ref} from "vue";

export const fittingList = {
    G12: {id: 1, short: 'G12', value: setMatText.select_fitting.G12},
    G34: {id: 2, short: 'G34', value: setMatText.select_fitting.G34},
    G34T: {id: 3, short: 'G34T', value: setMatText.select_fitting.G34T},
    G1: {id: 4, short: 'G1', value: setMatText.select_fitting.G1},
    SR8x200: {id: 5, short: 'SR8x200', value: setMatText.select_fitting.SR8x200},
    SR10x200: {id: 6, short: 'SR10x200', value: setMatText.select_fitting.SR10x200},
    SR38x400: {id: 7, short: 'SR38x400', value: setMatText.select_fitting.SR38x400},
    SR15x150: {id: 8, short: 'SR15x150', value: setMatText.select_fitting.SR15x150},
    SR18x150: {id: 9, short: 'SR18x150', value: setMatText.select_fitting.SR18x150},
    SR20x150: {id: 10, short: 'SR20x150', value: setMatText.select_fitting.SR20x150},
    SR22x150: {id: 11, short: 'SR22x150', value: setMatText.select_fitting.SR22x150},
    SR27x150: {id: 67, short: 'SR27x150', value: setMatText.select_fitting.SR27x150},
    SR22x300: {id: 12, short: 'SR22x300', value: setMatText.select_fitting.SR22x300},
    SR22x570: {id: 13, short: 'SR22x570', value: setMatText.select_fitting.SR22x570},
    KF16: {id: 14, short: 'KF16', value: setMatText.select_fitting.KF16},
    KF25: {id: 15, short: 'KF25', value: setMatText.select_fitting.KF25},
    KF40: {id: 16, short: 'KF40', value: setMatText.select_fitting.KF40},
    SW41: {id: 21, short: 'SW41', value: setMatText.select_fitting.SW41},
    CF25: {id: 25, short: 'CF25', value: setMatText.select_fitting.CF25},
    CF40: {id: 26, short: 'CF40', value: setMatText.select_fitting.CF40},
    FL25: {id: 27, short: 'FL25', value: setMatText.select_fitting.FL25},
    FL40: {id: 28, short: 'FL40', value: setMatText.select_fitting.FL40},
    SR22SR4751: {id: 29, short: 'SR22-14751', value: setMatText.select_fitting.SR22x2_4751},
    SR15SR4751: {id: 30, short: 'SR15-14751', value: setMatText.select_fitting.SR15x2_4751},
    SR20SR4751: {id: 31, short: 'SR20-14751', value: setMatText.select_fitting.SR20x2_4751},
    SR22SR4841: {id: 32, short: 'SR22-14841', value: setMatText.select_fitting.SR22x2_4841},
    SR15SR4841: {id: 33, short: 'SR15-14841', value: setMatText.select_fitting.SR15x2_4841},
    SR20SR4841: {id: 34, short: 'SR20-14841', value: setMatText.select_fitting.SR20x2_4841},
    SR22SR4816: {id: 35, short: 'SR22-24816', value: setMatText.select_fitting.SR22x2_I600},
    SR15SR4816: {id: 36, short: 'SR15-24816', value: setMatText.select_fitting.SR15x2_I600},
    SR20SR4816: {id: 37, short: 'SR20-24816', value: setMatText.select_fitting.SR20x2_I600},
    MCS: {id: 42, short: 'MCS', value: setMatText.select_fitting.MCS },
    MCSH: {id: 43, short: 'MCSH', value: setMatText.select_fitting.MCSH},
    MCSU: {id: 44, short: 'MCSU', value: setMatText.select_fitting.MCSU},
    MCSC: {id: 45, short: 'MCSC', value: setMatText.select_fitting.MCSC},
    DMCS: {id: 65, short: 'DMCS', value: setMatText.select_fitting.DMCS},
    SCS: {id: 46, short: 'SCS', value: setMatText.select_fitting.SCS},
    SCSH: {id: 47, short: 'SCSH', value: setMatText.select_fitting.SCSH},
    SCSU: {id: 48, short: 'SCSU', value: setMatText.select_fitting.SCSU},
    SCSC: {id: 49, short: 'SCSC', value: setMatText.select_fitting.SCSC},
    DSCS: {id: 5, short: 'DSCS', value: setMatText.select_fitting.DSCS},
    LS1: {id: 51, short: 'LS1', value: setMatText.select_fitting.LS1},
    LS2: {id: 52, short: 'LS2', value: setMatText.select_fitting.LS2},
    LS3: {id: 53, short: 'LS3', value: setMatText.select_fitting.LS3},
    LK1: {id: 54, short: 'LK1', value: setMatText.select_fitting.LK1},
    LK2: {id: 55, short: 'LK2', value: setMatText.select_fitting.LK2},
    LK3: {id: 56, short: 'LK3', value: setMatText.select_fitting.LK3},
    BL15: {id: 66, short: 'BL15', value: setMatText.select_fitting.BL15},
    BL20: {id: 38, short: 'BL20', value: setMatText.select_fitting.BL20},
    BL30: {id: 39, short: 'BL30', value: setMatText.select_fitting.BL30},
    ALBL30: {id: 17, short: 'ALBL30', value: setMatText.select_fitting.ALBL30},
    ALMC: {id: 18, short: 'ALMC', value: setMatText.select_fitting.ALMC},
    ALSC: {id: 19, short: 'ALSC', value: setMatText.select_fitting.ALSC},
    ALLS: {id: 20, short: 'ALLS', value: setMatText.select_fitting.ALLS},
    TLSC: {id: 18, short: 'TLSC', value: setMatText.select_fitting.TLMC},
    TLMC: {id: 19, short: 'TLMC', value: setMatText.select_fitting.TLSC},
    TLLS: {id: 20, short: 'TLLS', value: setMatText.select_fitting.TLLS},
    ALBL20: {id: 22, short: 'ALBL20', value: setMatText.select_fitting.ALBL20},
    TLBL20: {id: 23, short: 'TLBL20', value: setMatText.select_fitting.TL20},
    TLBL30: {id: 24, short: 'TLBL30', value: setMatText.select_fitting.TL30},
    BA: {id: 63, short: 'BA', value: setMatText.select_fitting.BA},
    BG12: {id: 64, short: 'BG12', value: setMatText.select_fitting.BA12},
    BG38: {id: 68, short: 'BG12', value: setMatText.select_fitting.BA38},
}

export const tptypes = {
    S: {id: 1, short: 'S', value: 'S (PtRh10 - Pt)'},
    R: {id: 2, short: 'R', value: 'R (PtRh13 - Pt)'},
    B: {id: 3, short: 'B', value: 'B (PtRh30 - PtRh6)'},
    K: {id: 4, short: 'K', value: 'K (NiCr - NiAl)'},
    N: {id: 5, short: 'N', value: 'N (NiCrSi - NiSil)'},
    J: {id: 6, short: 'J', value: 'J (Fe - CuNi)'},
    C: {id: 8, short: 'C', value: 'U (WRe26 - WRe5)'},
    T: {id: 9, short: 'T', value: 'T (Cu - CuNi)'},
    E: {id: 10, short: 'E', value: 'E (NiCr - CuNi)'},
    L: {id: 11, short: 'L', value: 'L (Fe - CuNi) DIN 5843'},
}

export const drucktypes = ref([
    {id: 1, label: setMatText.drucktype_protective},
    {id: 2, label: setMatText.drucktype_vacuum},
    {id: 3, label: setMatText.drucktype_atmospheric},
    {id: 4, label: setMatText.drucktype_other },
])


export const maintypes = ref([
    {id: 8, label: setMatText.maintype_tc},
    {id: 9, label: setMatText.maintype_oxygen_probe},
    {id: 10, label: setMatText.maintype_tc_sat},
    {id: 16, label: setMatText.maintype_tc_mic},
    {id: 26, label: setMatText.maintype_fdf},
    {id: 30, label: setMatText.maintype_acc},
])

export const tpnums = ref([
    {id: 1, short: '01', value: setMatText.tpNumSingle},
    {id: 2, short: '02', value: setMatText.tpNumDuplex},
    {id: 3, short: '03', value: setMatText.tpNumTriple},
])

export const pinnums = {
    P2: {short: 'P2', value: '2 Pin'},
    P3: {short: 'P3', value: '3 Pin'},
}

export const genders = {
    M: {short: 'M', value: setMatText.select_label_case_gender_m},
    F: {short: 'F', value: setMatText.select_label_case_gender_f},
}

export const casematerials = {
    EC: {short: 'EC', value: setMatText.select_label_case_mat_ec},
    ST: {short: 'ST', value: setMatText.select_label_case_mat_sd},
    HT: {short: 'HT', value: setMatText.select_label_case_mat_ht},
    UH: {short: 'UH', value: setMatText.select_label_case_mat_uht},
    CC: {short: 'CC', value: setMatText.select_label_case_mat_cc},
}

export const caseforms = {
    MC: {short: 'MC', value: setMatText.select_label_case_form_mc},
    MCD: {short: 'MCD', value: setMatText.select_label_case_form_dmc},
    SC: {short: 'SC', value: setMatText.select_label_case_form_sc},
    SCD: {short: 'SCD', value: setMatText.select_label_case_form_dsc},
}

export const dfForms = {
    G34: {short: 'G34', value: setMatText.select_fitting.FeedG34},
    G1: {short: 'G1', value: setMatText.select_fitting.FeedG1},
    KF25: {short: 'KF25', value: setMatText.select_fitting.FeedKF25},
    KF40: {short: 'KF40', value: setMatText.select_fitting.FeedKF40},
    BoxKF40: {short: 'BoxKF40', value: setMatText.select_fitting.FeedBoxKF40},
    FLDN80: {short: 'FLDN80', value: setMatText.select_fitting.FeedFLDN80},
}

export const fixedOptions = {

    fixed: {short:'fixed', value:setMatText.select_df_feed_fixed},
    loose: {short:'loose', value:setMatText.select_df_feed_loose},

}

export const feedTypes = {

    mte15: {short:'mte15', value:setMatText.select_df_feed_type_mte15},
    mte20: {short:'mte20', value:setMatText.select_df_feed_type_mte20},
    mte30: {short:'mte30', value:setMatText.select_df_feed_type_mte30},
    cable: {short:'cable', value:setMatText.select_df_feed_type_cable},

}

export const optcnum = {
    0: { short: '0', value: setMatText.select_tp_set_none},
    1:{ short: '1', value: setMatText.select_tp_set_incl}
}

export const powerSupplyList = {

    S230: {short:'S230', value:setMatText.select_tv_power_230AC},
    S048: {short:'S048', value:setMatText.select_tv_power_48DC},

}

export const outputTypeList = {

    a420: {short:'a420', value:setMatText.select_tv_output_420ma},
    v110: {short:'v110', value:setMatText.select_tv_output_110v},
    null: {short:'null', value:setMatText.select_tv_output_none},

}

export const airSupplyTypeList = {

    mp: {short:'mp', value:setMatText.select_asu_smp},
    dl: {short:'dl', value:setMatText.select_asu_dl},

}
export const asuCasingTypeList = {

    asuopen: {short:'asuopen', value:setMatText.select_asu_case_open},
    asuclosed: {short:'asuclosed', value:setMatText.select_asu_case_closed},

}
